export const Constants = {
  DEFAULT_USER_NAME: "Chingarian 🔥",
  LIVESTREAM_BASE_URL: "https://chingari.io/live/",
  AUDIOSTREAM_BASE_URL: "https://chingari.io/room/",
  PLAY_STORE: "https://astroliveapp.page.link/downloadnow",
  APPLE_STORE: "https://astroliveapp.page.link/downloadnow",
  LIVESTREAM_ROOM_BASE_URL: "https://dev-webview.chingari.io/",
  INPUT_LABEL_17:
    "Where you get to know about Chingari live streaming feature?",
};
